import { colors } from "../../../global";

const SummaryKPI = ({ kpis = {} }) => {
  const totalTickets = Number(kpis.totalTickets || 0);
  const totalHours = Number(kpis.totalTimes || 0);

  return (
    <div className="flex gap-4 mb-6">
      {/* ===== TOTAL TICKETS ===== */}
      <div className="flex-1 bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-2">
          <p
            className="text-xs font-medium uppercase tracking-wide"
            style={{ color: colors.secondary }}
          >
            Total Tickets
          </p>
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${colors.primary}15` }}
          >
            <svg
              className="w-4 h-4"
              style={{ color: colors.primary }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
          </div>
        </div>

        <p className="text-2xl font-bold" style={{ color: colors.primary }}>
          {totalTickets.toLocaleString()}
        </p>
      </div>

      {/* ===== TOTAL HOURS ===== */}
      <div className="flex-1 bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-2">
          <p
            className="text-xs font-medium uppercase tracking-wide"
            style={{ color: colors.secondary }}
          >
            Total Time (hrs)
          </p>
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${colors.accent}15` }}
          >
            <svg
              className="w-4 h-4"
              style={{ color: colors.accent }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        <p className="text-2xl font-bold" style={{ color: colors.primary }}>
          {totalHours.toFixed(1)} hrs
        </p>
      </div>
    </div>
  );
};

export default SummaryKPI;
